import React, { useEffect, useRef, useState } from "react"
import { Container, Row, Col, Modal, Button, Form, Breadcrumb, Table, Tabs, Tab } from 'react-bootstrap';
import moment from "moment/moment";
import Select from 'react-select';
import { displayError, displaySuccess, getAllTimezones } from '../../Utils/utils';
import LoadingSpinner from '../LoadingSpinner/index'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import './EditModal.css'
import config from "../../config/config";
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';

const EditModal = (props) => {
  const { showModal, setShowModal, selectedRow } = props;
  const [timezones, setTimezones] = useState([])
  const [firstName , setFirstName] = useState('')
  const [lastName , setLastName] = useState('')
  const [courseNumber, setCourseNumber] = useState('')
  const [startDate, setStartDate] = useState(new Date())
  const [endDate, setEndDate] = useState(new Date())
  const [phoneNumber, setPhoneNumber] = useState('')
  const [homeEmail, setHomeEmail] = useState('')
  const [workEmail, setWorkEmail] = useState('')
  const [timezone, setTimezone] = useState([])
  const [dataRow, setDataRow] = useState({})
  const [isLoading, setIsLoading] = useState(false);
  const [studentId, setStudentId] = useState('');
  const handleCloseModal = () => {
    setShowModal(false)
    setDataRow([])
  }
  const [mondayFrom, setMondayFrom] = useState('')
  const [tueFrom, setTueFrom] = useState('')
  const [wedFrom, setWedFrom] = useState('')
  const [thurFrom, setThurFrom] = useState('')
  const [friFrom, setFriFrom] = useState('')
  const [satFrom, setSatFrom] = useState('')
  const [sunFrom, setSunFrom] = useState('')

  const [monTo, setMonTo] = useState('');
  const [tueTo, setTueTo] = useState('');
  const [wedTo, setWedTo] = useState('');
  const [thurTo, setThurTo] = useState('');
  const [friTo, setFriTo] = useState('');
  const [satTo, setSatTo] = useState('');
  const [sunTo, setSunTo] = useState('');

  const getTimezones = async () => {
    var temp = []
    var res = await getAllTimezones()
    if (res.status === 200) {
      res.data.map((e) => {
        if (e.name === selectedRow.TIMEZONE) {
          setTimezone({ value: e.name, label: e.name })
        }
        temp.push({ value: e.name, label: e.name })
      })
      setTimezones(temp)
    }
  }

  const saveDateChanges = async () => {
    dataRow.FIRSTNAME = firstName
    dataRow.LASTNAME = lastName
    dataRow.COURSE_NUMBER = courseNumber
    dataRow.TIMEZONE = timezone.value
    dataRow.AVAILABLE_START_DATE = moment(startDate).format("MM/DD/YYYY")
    dataRow.AVAILABLE_END_DATE = moment(endDate).format("MM/DD/YYYY")
    dataRow.PHONE = phoneNumber
    dataRow.HOME_EMAIL = homeEmail
    dataRow.WORK_EMAIL = workEmail
    dataRow.MON_FROM = mondayFrom
    dataRow.TUE_FROM = tueFrom
    dataRow.WED_FROM = wedFrom
    dataRow.THUR_FROM = thurFrom
    dataRow.FRI_FROM = friFrom
    dataRow.SAT_FROM = satFrom
    dataRow.SUN_FROM = sunFrom
    dataRow.MON_TO = monTo
    dataRow.TUE_TO = tueTo
    dataRow.WED_TO = wedTo
    dataRow.THUR_TO = thurTo
    dataRow.FRI_TO = friTo
    dataRow.SAT_TO = satTo
    dataRow.SUN_TO = sunTo
    // setShowModal(false)
    updateData()
    // alert("In progress")
  }
  const updateData = async () => {
    setIsLoading(true)
    const request = {
      'LD_SID': studentId,
      'FIRSTNAME': firstName,
      'LASTNAME': lastName,
      'COURSE_NUMBER': courseNumber,
      'TIMEZONE': timezone.value,
      'AVAILABLE_START_DATE': moment(startDate).format("DD-MMM-YY"),
      'AVAILABLE_END_DATE': moment(endDate).format("DD-MMM-YY"),
      'PHONE': phoneNumber,
      'HOME_EMAIL': homeEmail,
      'WORK_EMAIL': workEmail,
    }
    let path = config.siteUrl;
    const res = await axios.post(path + '/classes/update-raw-data', request, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',

      }
    })
    if (res.data.status == 200) {
      setIsLoading(false)
      setShowModal(false)
      toast.success(res.data.message)
    } else {
      setIsLoading(false)

      console.log(res)
      // toast.error(res)
    }

  }
  useEffect(() => {
    if (showModal == true) {
      getTimezones()
    }
  }, [showModal])


  useEffect(() => {
    // setIsLoading(true)
    if (selectedRow != undefined) {
      setDataRow(selectedRow)
      setStudentId(selectedRow?.LD_SID)
      setFirstName(selectedRow.FIRSTNAME)
      setLastName(selectedRow.LASTNAME)
      setCourseNumber(selectedRow.COURSE_NUMBER)
      setStartDate(new Date(selectedRow.AVAILABLE_START_DATE))
      setEndDate(new Date(selectedRow.AVAILABLE_END_DATE))
      setPhoneNumber(selectedRow.PHONE)
      setHomeEmail(selectedRow.HOME_EMAIL)
      setWorkEmail(selectedRow.WORK_EMAIL)
      setMondayFrom(selectedRow.MON_FROM)
      setTueFrom(selectedRow.TUE_FROM)
      setWedFrom(selectedRow.WED_FROM)
      setThurFrom(selectedRow.THUR_FROM)
      setFriFrom(selectedRow.FRI_FROM)
      setSatFrom(selectedRow.SAT_FROM)
      setSunFrom(selectedRow.SUN_FROM)
      setMonTo(selectedRow.MON_TO)
      setTueTo(selectedRow.TUE_TO)
      setWedTo(selectedRow.WED_TO)
      setThurTo(selectedRow.THUR_TO)
      setFriTo(selectedRow.FRI_TO)
      setSatTo(selectedRow.SAT_TO)
      setSunTo(selectedRow.SUN_TO)
    }
    // setIsLoading(false)

  }, [selectedRow])



  return (
    <>
      <div>
        <ToastContainer
          position="top-center"
        />
        <LoadingSpinner isLoading={isLoading} />
        <Modal size="lg" show={showModal} onHide={handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title>View/Edit Student Data</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container>
              <Row>
                <Col md={6} xs={12}>
                  <Form.Group className="mb-3 basic-form">
                    <Form.Label>Schedule For : &nbsp;</Form.Label>
                    <Form.Label>{dataRow.FIRSTNAME + ' ' + dataRow.LASTNAME}</Form.Label>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col md={6} xs={12}>
                  <Form.Group className="mb-3 basic-form" >
                    <Form.Label>Student Timezone : &nbsp;</Form.Label>
                    <Form.Label>{dataRow.TIMEZONE}</Form.Label>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
              <Col md={6} xs={12}>
                  <Form.Group className="mb-3 basic-form" >
                    <Form.Label>First Name : &nbsp;</Form.Label>
                    <Form.Control className='inputt' type="text" value={firstName} placeholder="First Name"
                      onChange={(e) => { setFirstName(e.target.value) }}
                    />
                  </Form.Group>
                </Col>
                <Col md={6} xs={12}>
                  <Form.Group className="mb-3 basic-form" >
                    <Form.Label>Last Name : &nbsp;</Form.Label>
                    <Form.Control className='inputt' type="text" value={lastName} placeholder="Last Name"
                      onChange={(e) => { setLastName(e.target.value) }}
                    />
                  </Form.Group>
                </Col>
                <Col md={6} xs={12}>
                  <Form.Group className="mb-3 basic-form" >
                    <Form.Label>Class Number : &nbsp;</Form.Label>
                    <Form.Control className='inputt' type="text" value={courseNumber} placeholder="Class Number"
                      onChange={(e) => { setCourseNumber(e.target.value) }}
                    />
                  </Form.Group>
                </Col>
                <Col md={6} xs={12}>
                  <Form.Group className="mb-3 basic-form">
                    <Form.Label>Time Zone : &nbsp;</Form.Label>
                    <Select
                      name="colors"
                      value={timezone}
                      options={timezones}
                      className="basic-multi-select "
                      classNamePrefix="select"
                      onChange={(e) => setTimezone(e)}
                    />
                  </Form.Group>
                </Col>
                <Col md={6} xs={12}>
                  <Form.Group className=" basic-form" >
                    <Form.Label>Available Start Date : &nbsp;</Form.Label>
                    {/* <Form.Control className='inputt' value={moment(startDate).format('MM/DD/YYYY')} type="text" placeholder="Available Start Date"
                    onChange={(e) => {
                      setStartDate(e.target.value)
                    }
                    }
                  /> */}

                  </Form.Group>
                  <Row className="datepick mb-2">
                    <DatePicker
                      selected={startDate}
                      onChange={(date) => setStartDate(date)}
                      dateFormat="MM/dd/yyyy"
                      className="inputt"
                    />
                  </Row>
                </Col>
                <Col md={6} xs={12}>
                  <Form.Group className=" basic-form">
                    <Form.Label>Available End Date : &nbsp;</Form.Label>
                    {/* <Form.Control className='inputt' type="text" placeholder="Available End Date"
                    onChange={(e) => { setEndDate(e.target.value) }
                    }
                    value={moment(endDate).format('MM/DD/YYYY')}
                  /> */}
                  </Form.Group>
                  <Row className="datepick mb-2">
                    <DatePicker
                      selected={endDate}
                      onChange={(date) => setEndDate(date)}
                      dateFormat="MM/dd/yyyy"
                      className="inputt"
                    />
                  </Row>
                </Col>
                <Col md={6} xs={12}>
                  <Form.Group className="mb-3 basic-form">
                    <Form.Label>Phone Number : &nbsp;</Form.Label>
                    <Form.Control className='inputt' type="text" placeholder="Phone Number"
                      onChange={(e) => { setPhoneNumber(e.target.value) }
                      }
                      value={phoneNumber}
                    />
                  </Form.Group>
                </Col>
                <Col md={6} xs={12}>
                  <Form.Group className="mb-3 basic-form">
                    <Form.Label>Home Email : &nbsp;</Form.Label>
                    <Form.Control className='inputt' type="text" placeholder="Home Email"
                      onChange={(e) => { setHomeEmail(e.target.value) }
                      }
                      value={homeEmail}
                    />
                  </Form.Group>
                </Col>
                <Col md={6} xs={12}>
                  <Form.Group className="mb-3 basic-form">
                    <Form.Label>Work Email : &nbsp;</Form.Label>
                    <Form.Control className='inputt' type="text" placeholder="Work Email"
                      onChange={(e) => { setWorkEmail(e.target.value) }
                      }
                      value={workEmail}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <div className="alert-modal-box mt-2">
                  <p>Data <strong>BELOW</strong> will be modified for processing only, and <strong>NOT SAVED.</strong></p>
                  <p>Please enter time in HHMM format according to the student timezone.</p>
                </div>
              </Row>
              <Row>
                <Col md={6} xs={12}>
                  <Form.Group className="mb-3 basic-form">
                    <Row >
                      <Col md={4} xs={12} className="">
                        <Form.Label>MON</Form.Label>
                      </Col>
                      <Col md={4} xs={12} className="">
                        <Form.Control className='inputt' type="text" placeholder=""
                          onChange={(e) => {
                            setMondayFrom(e.target.value)
                          }}
                          style={{ padding: '6px' }}
                          value={mondayFrom}
                        />
                      </Col>
                      <Col md={4} xs={12} className="">
                        <Form.Control className='inputt' type="text" placeholder=""
                          onChange={(e) => {
                            setMonTo(e.target.value)
                          }}
                          style={{ padding: '6px' }}
                          value={monTo}
                        />
                      </Col>
                    </Row>
                  </Form.Group>
                </Col>
                <Col md={6} xs={12}>
                  <Form.Group className="mb-3 basic-form">
                    <Row >
                      <Col md={4} xs={12}>
                        <Form.Label>TUE</Form.Label>
                      </Col>
                      <Col md={4} xs={12}>
                        <Form.Control className='inputt' type="text" placeholder=""
                          onChange={(e) => {
                            setTueFrom(e.target.value)
                          }}
                          value={tueFrom}
                        />
                      </Col>
                      <Col md={4} xs={12}>
                        <Form.Control className='inputt' type="text" placeholder=""
                          onChange={(e) => {
                            setTueTo(e.target.value)
                          }}
                          value={tueTo}
                        />
                      </Col>
                    </Row>
                  </Form.Group>
                </Col>
                <Col md={6} xs={12}>
                  <Form.Group className="mb-3 basic-form">
                    <Row >
                      <Col md={4} xs={12}>
                        <Form.Label>WED</Form.Label>
                      </Col>
                      <Col md={4} xs={12}>
                        <Form.Control className='inputt' type="text" placeholder=""
                          onChange={(e) => {
                            setWedFrom(e.target.value)
                          }}
                          value={wedFrom}
                        />
                      </Col>
                      <Col md={4} xs={12}>
                        <Form.Control className='inputt' type="text" placeholder=""
                          onChange={(e) => {
                            setWedTo(e.target.value)
                          }}
                          value={wedTo}
                        />
                      </Col>
                    </Row>
                  </Form.Group>
                </Col>
                <Col md={6} xs={12}>
                  <Form.Group className="mb-3 basic-form">
                    <Row >
                      <Col md={4} xs={12}>
                        <Form.Label>THUR</Form.Label>
                      </Col>
                      <Col md={4} xs={12}>
                        <Form.Control className='inputt' type="text" placeholder=""
                          onChange={(e) => {
                            setThurFrom(e.target.value)
                          }}
                          value={thurFrom}
                        />
                      </Col>
                      <Col md={4} xs={12}>
                        <Form.Control className='inputt' type="text" placeholder=""
                          onChange={(e) => {
                            setThurTo(e.target.value)
                          }}
                          value={thurTo}
                        />
                      </Col>
                    </Row>
                  </Form.Group>
                </Col>
                <Col md={6} xs={12}>
                  <Form.Group className="mb-3 basic-form">
                    <Row >
                      <Col md={4} xs={12}>
                        <Form.Label>FRI</Form.Label>
                      </Col>
                      <Col md={4} xs={12}>
                        <Form.Control className='inputt' type="text" placeholder=""
                          onChange={(e) => {
                            setFriFrom(e.target.value)
                          }}
                          value={friFrom}
                        />
                      </Col>
                      <Col md={4} xs={12}>
                        <Form.Control className='inputt' type="text" placeholder=""
                          onChange={(e) => {
                            setFriTo(e.target.value)
                          }}
                          value={friTo}
                        />
                      </Col>
                    </Row>
                  </Form.Group>
                </Col>
                <Col md={6} xs={12}>
                  <Form.Group className="mb-3 basic-form">
                    <Row >
                      <Col md={4} xs={12}>
                        <Form.Label>SAT</Form.Label>
                      </Col>
                      <Col md={4} xs={12}>
                        <Form.Control className='inputt' type="text" placeholder=""
                          onChange={(e) => {
                            setSatFrom(e.target.value)
                          }}
                          value={satFrom}
                        />
                      </Col>
                      <Col md={4} xs={12}>
                        <Form.Control className='inputt' type="text" placeholder=""
                          onChange={(e) => {
                            setSatTo(e.target.value)
                          }}
                          value={satTo}
                        />
                      </Col>
                    </Row>
                  </Form.Group>
                </Col>
                <Col md={6} xs={12}>
                  <Form.Group className="mb-3 basic-form">
                    <Row >
                      <Col md={4} xs={12}>
                        <Form.Label>SUN</Form.Label>
                      </Col>
                      <Col md={4} xs={12}>
                        <Form.Control className='inputt' type="text" placeholder=""
                          onChange={(e) => {
                            setSunFrom(e.target.value)
                          }}
                          value={sunFrom}
                        />
                      </Col>
                      <Col md={4} xs={12}>
                        <Form.Control className='inputt' type="text" placeholder=""
                          onChange={(e) => {
                            setSunTo(e.target.value)
                          }}
                          value={sunTo}
                        />
                      </Col>
                    </Row>
                  </Form.Group>
                </Col>
              </Row>
            </Container>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Close
            </Button>
            <Button variant="primary" onClick={() => {
              saveDateChanges()
            }}>
              Save Changes
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  )
}
export default EditModal